function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import AppBanner from './AppBanner';
import BackArrowLink from './BackArrowLink';
import Drawer from './Drawer';
import Header from './Header';
import { styles as navbarStyles } from './Navbar';
import ToggleButton from './ToggleButton';
import useResponsive from './useResponsive';
const styles = require('./Page-styles.module.scss');
const DEFAULT_HIDE_DRAWER_BREAKPOINT = 'md';
const PageContext = React.createContext(null);
export function useSetHideDrawerBreakpoint(breakpoint) {
  const {
    setHideDrawerBreakpoint
  } = useContext(PageContext);
  useEffect(() => {
    setHideDrawerBreakpoint(breakpoint);
    return () => {
      setHideDrawerBreakpoint(DEFAULT_HIDE_DRAWER_BREAKPOINT);
    };
  }, [setHideDrawerBreakpoint, breakpoint]);
}
export function useToggleDrawer() {
  return useContext(PageContext).toggleDrawer;
}

function Page({
  children
}) {
  const [hasDrawer, registerDrawer] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false); // FIXME: This is to allow the legacy study image view to hide the sidebar
  //  at smaller sizes. Remove this when we remove the old study image view.

  const [hideDrawerBreakpoint, setHideDrawerBreakpoint] = useState(DEFAULT_HIDE_DRAWER_BREAKPOINT);
  const context = useMemo(() => ({
    hasDrawer,
    showDrawer,
    hideDrawerBreakpoint,
    registerDrawer,
    setHideDrawerBreakpoint,
    toggleDrawer: nextShow => {
      setShowDrawer(prevShow => nextShow == null ? !prevShow : nextShow);
    }
  }), [hasDrawer, hideDrawerBreakpoint, showDrawer]);
  return React.createElement(PageContext.Provider, {
    value: context
  }, children);
}

function PageContainer({
  center,
  className,
  children,
  ...props
}) {
  return React.createElement("div", _extends({
    className: classNames(className, styles.container, center && styles.center)
  }, props), children);
}

function PageSidePanel(props) {
  const {
    showDrawer,
    hideDrawerBreakpoint,
    toggleDrawer,
    registerDrawer
  } = useContext(PageContext);
  const useDrawer = useResponsive(hideDrawerBreakpoint, 'down');

  const handleHide = () => toggleDrawer(false);

  useEffect(() => {
    if (!useDrawer) toggleDrawer(false);
    registerDrawer(useDrawer);
    return () => {
      registerDrawer(false);
    };
  }, [useDrawer, registerDrawer, toggleDrawer]);
  return useDrawer ? React.createElement(Drawer, _extends({}, props, {
    show: showDrawer,
    onHide: handleHide,
    className: classNames(props.className, styles.sidePanelDrawer)
  })) : React.createElement("div", _extends({}, props, {
    className: classNames(props.className, styles.sidePanelStatic)
  }));
}

function PageMain({
  className,
  ...props
}) {
  return React.createElement("main", _extends({}, props, {
    className: classNames(className, styles.main)
  }));
}

function PageHeader({
  backTo,
  sticky,
  children,
  className
}) {
  const {
    hasDrawer,
    toggleDrawer
  } = useContext(PageContext);
  let action;
  if (backTo) action = React.createElement(BackArrowLink, {
    to: backTo
  });else if (hasDrawer) action = React.createElement(ToggleButton, {
    onClick: () => toggleDrawer()
  });
  return React.createElement(Header, {
    className: classNames(className, sticky && styles.sticky)
  }, action, children);
}

Page.Container = PageContainer;
Page.SidePanel = PageSidePanel;
Page.Main = PageMain;
Page.Header = PageHeader;
export default Page;